export function formatIntger(e) {
    // Allow only digits and specific control keys (backspace, delete, arrow keys, etc.)
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Home", "End"];
    if (!allowedKeys.includes(e.key) && (isNaN(parseInt(e.key)) || parseInt(e.key) < 0 || parseInt(e.key) > 9)) {
        e.preventDefault();
    }
  }